import Sync from '@clearkit/icons/glyphs/Sync';
import Salesforce from '@clearkit/icons/services/Salesforce';
import moment from 'moment';

const inProgressStatus = 'in_progress';

function nextSyncMessage(inProgress, syncedAt) {
  if (inProgress) return 'Update in progress...';
  if (!syncedAt)
    return 'Salesforce data not yet synced. First sync in an hour.';

  const lastSync = moment(syncedAt).fromNow();
  const nextSync = nextSyncTime(syncedAt).fromNow();

  return `Salesforce data last updated ${lastSync}. Next sync ${nextSync}.`;
}

function nextSyncTime(syncedAt) {
  // If sync happened in the past 24 hours, adds a day to `syncedAt`.
  // Otherwise, sync will probably happen at some point in the next hour.
  if (
    moment()
      .subtract(1, 'day')
      .isBefore(syncedAt)
  ) {
    return moment(syncedAt).add(1, 'day');
  }

  return moment().add(1, 'hour');
}

export default ({ loading, status, syncedAt }) => {
  const inProgress = status == inProgressStatus;
  const message = nextSyncMessage(inProgress, syncedAt);

  return (
    <div className="flex items-center h-12 px-4 py-2 rounded-b bg-gray-0 space-x-2 text-gray">
      {inProgress && !loading && (
        <>
          <Salesforce width={18} />
          <Sync width={18} />
        </>
      )}
      <div
        className={classnames(
          'flex items-center text-xs font-medium text-gray space-x-1',
          { 'ck-skeleton': loading },
        )}>
        <span>{message}</span>
      </div>
    </div>
  );
};
